var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeCoverRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "We_Cover_Right_2",
    "data-name": "We Cover Right 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 279.66 225.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .we-cover-right-1 {\n        fill: #799dab;\n      }\n\n      .we-cover-right-1, .we-cover-right-2 {\n        stroke-width: 0px;\n      }\n\n      .we-cover-right-3 {\n        clip-path: url(#we-cover-right-clip);\n      }\n\n      .we-cover-right-2 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "we-cover-right-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "we-cover-right-2",
    width: 279.66,
    height: 225.37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "We_Cover_Right_1",
    "data-name": "We Cover Right 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "we-cover-right-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "we-cover-right-1",
    d: "M339.73,23.42l-281.26-.43c-15.71,0-28.72,10.62-28.72,23.45s13,23.45,28.72,23.45h144.12c15.71,0,28.71,10.18,28.71,23.01s-13,23.45-28.71,23.45h-61.22c-15.71,0-28.72,10.18-28.72,23.01s13,23.45,28.72,23.45h198.37V23.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeCoverRight);
export default __webpack_public_path__ + "static/media/WeCover-Right.0178546471584928854caa5deaf048a2.svg";
export { ForwardRef as ReactComponent };